export default {
  type: "Projekttyp",
  healthProgram: "Gesundheitsprogramm",
  careProgram: "Pflegeprogramm",
  nationalHealthProgram: "Programm für öffentliche Gesundheit",
  progress: "Projektfortschritt",
};
